import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import ModalCloseButton from '../../components/generic/ModalCloseButton';

const SyllabusModal = ({ open, onOpenChange, dialogContent }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="[&>button]:hidden">
        <div className="relative">
          <DialogTitle>{dialogContent?.title}</DialogTitle>
          <ModalCloseButton onClick={() => onOpenChange(false)} />
          <div className="dialog-syllabus syllabus-content">
            <style jsx>{`
              .dialog-syllabus h1 {
                font-size: 1.2rem;
                font-weight: 600;
                margin-bottom: 0.75rem;
              }
              .dialog-syllabus h2 {
                font-size: 1rem;
                font-weight: 500;
                margin-top: 1.2rem;
                margin-bottom: 0.6rem;
              }
              .dialog-syllabus ul {
                list-style-type: disc;
                padding-left: 1.8rem;
                margin-bottom: 1.2rem;
              }
              .dialog-syllabus li {
                margin-bottom: 0.35rem;
              }
              .dialog-syllabus p {
                font-size: 1rem;
                margin-bottom: 0.5rem;
              }
            `}</style>
            <div dangerouslySetInnerHTML={{ __html: dialogContent.syllabus }} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SyllabusModal;
